import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-nav-27",
  "use": "icon-icon-nav-27-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-nav-27\"><path d=\"M512 250.24A412.864 412.864 0 0 0 128 512a412.864 412.864 0 0 0 384 261.76A412.864 412.864 0 0 0 896 512a412.864 412.864 0 0 0-384-261.76z m0 436.288a174.592 174.592 0 0 1 0-349.056 174.592 174.592 0 0 1 0 349.056z m0-279.232c-57.92 0-104.704 46.72-104.704 104.704 0 57.92 46.72 104.704 104.704 104.704 57.92 0 104.704-46.72 104.704-104.704 0-57.92-46.72-104.704-104.704-104.704z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/icon-nav-27.svg
// module id = 9fWq
// module chunks = 3